<app-menu></app-menu>

<div class="container-fluid pt-5">

    <div class="row d-flex align-items-center" >
        <div class="col-md-6">
            <div class="row d-flex justify-content-center ">
                <div class="col-md-6">
                    
                    <div class="d-flex justify-content-center mt-3">
                        <img
                          style="width: 100px"
                          class="d-flex justify-content-center" routerLink='/home'
                          src="https://i.imgur.com/5KOEUob.png"
                          alt="Logo repassa"
                        />
                      </div>

                    <h3 class="text-center mb-4">Login</h3>

                    <hr class="mt-0 mb-4">

                    <div class="form-group">
                        <label for="email">
                            <h4>Email</h4>
                        </label>
                        <input [(ngModel)]='userLogin.email' login="" class="form-control" type="email" name="email" id="email"
                        placeholder="exemplo@exemplo.com">
                    </div>

                    <div class="form-group mt-2">
                        <label for="senha">
                            <h4>Senha </h4>
                        </label>
                        <input [(ngModel)]='userLogin.senha' class="form-control" type="password" name="senha" id="senha"
                        placeholder="Digite sua senha">
                    </div>

                    <div class="d-flex justify-content-center mt-4">
                        <button (click)='entrar()' id="botaoentrar" type="submit" class="btn mt-2">Entrar</button>
                    </div>

                    <hr class="mt-4 mb-2">

                    <p class="text-center">
                        Ainda não tem cadastro?  
                        <a id="linkfora" routerLink="/cadastrar">Cadastre-se</a>
                    </p>

                    <p class="text-center">
                        Esqueceu sua senha? 
                        <a id="linkfora" href="">Clique aqui</a>
                    </p>

                </div>
            </div>

        </div>

        <div class="col-md-6 mt-5 mb-2"  id="img-bg">

        </div>
    </div>

    
</div>

<app-rodape></app-rodape>


